import GuestHubGuestList from "./GuestHubGuestList";

export default GuestHubGuestList;
